import { useQuery } from "@tanstack/react-query";
import Select, { SelectProps } from "components/select";
import { rmBedTypApi } from "components/api/comm";
import { IRmComm, ISelect } from "interface";
import { useRef } from "react";
import useAuthStore from "store/auth";

interface IProps extends Omit<SelectProps, "options"> {
  isReset?: boolean;
  select?(inf: any): void;
}

export default function BadTypCdSelect({
  defaultValue,
  dataTyp,
  isReset,
  isUpdateAble,
  select,
}: IProps) {
  const isLogin = useAuthStore((state) => state.isLogin);
  const rmBedTypRef = useRef<ISelect[]>([]);
  useQuery({
    queryKey: ["rmBedTypList"],
    queryFn: () => {
      return rmBedTypApi();
    },
    enabled: isLogin,
    select: (data) => {
      if (data) {
        rmBedTypRef.current = data.data?.cdList.map((typ: IRmComm) => {
          return {
            ko: typ.langCd === "ko" ? typ.codNm : "",
            en: typ.langCd === "en" ? typ.codNm : "",
            value: typ.lodCd,
            code: typ.lodCd,
          };
        });
      }
    },
  });

  return (
    <>
      <Select
        name={"bedTypCd"}
        styles="bg-white border-1"
        dataTyp={dataTyp}
        defaultValue={defaultValue}
        options={rmBedTypRef.current}
        isUpdateAble={isUpdateAble}
        isReset={isReset}
        onSelect={(option) => select && select(option.code)}
      />
    </>
  );
}
